module.exports = __webpack_public_path__ + "media/images/front/treatment_support/setting_add_home_screen/img08-6ea3584061c428ceac1b651b817f2e3f.png";